module.exports = __webpack_public_path__ + "img/2.37d1eb84.png";